import { AccountBalance } from "@mui/icons-material";
import { Typography } from "@mui/material";
import { useLoaderData } from "react-router-dom";

import Navigation from "../../../../../components/navigations/finance/cases/detail/navigation";

export default () => {
  const { _case, client } = useLoaderData();
  return (
    <Navigation activeTab="details" _case={_case}>
      <div className="align-start m-5 flex h-[calc(100vh-15rem)] w-full flex-col justify-start gap-3 p-4">
        <div className="flex w-full flex-row items-start">
          <div className="flex w-1/5 flex-col p-2">
            <Typography className="text-md w-full text-nowrap normal-case text-gray-400">
              Client Name:
            </Typography>
            <Typography className="w-full p-2 text-sm normal-case text-black">
              {_case.client.name}
            </Typography>
          </div>

          <div className="flex-1 p-2">
            <Typography className="flex flex-row items-baseline">
              <span className="px-2">
                <AccountBalance />
              </span>
              {_case.lawFirmName}
            </Typography>
          </div>
        </div>
        <div className="flex flex-col p-2">
          <Typography className="text-md normal-case text-gray-400">Date Of Birth:</Typography>
          <Typography className="p-2 text-sm normal-case text-black">
            {client.dateOfBirth ? client.dateOfBirth.toLocaleDateString() : "N/A"}
          </Typography>
        </div>
        <div className="flex flex-col p-2">
          <Typography className="text-md normal-case text-gray-400">Date of Incident:</Typography>
          <Typography className="p-2 text-sm normal-case text-black">
            {_case.dateOfAccident.toLocaleDateString()}
          </Typography>
        </div>
      </div>
    </Navigation>
  );
};
